import React, {Component} from 'react';
import {Link} from 'react-router-dom';
 

// Layout
import Header from "../layout/header2";
import Footer from "../layout/footer";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";
import servicesPic1 from "../../images/cover.png";
 
class ServiceCover extends Component{
	
	render(){
		return (
			<>
				
				<Header />
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Cobertura</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><a href="index.html"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Inicio</a></li>
											<li className="breadcrumb-item active" aria-current="page">Cobertura</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>
					
					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								<div className="col-lg-8 mb-30">
									<div className="ttr-media mb-30">
										<img src={servicesPic1} className="rounded" alt=""/>
									</div>
									<div className="clearfix">
										<div className="head-text mb-30">
											<h2 className="title mb-15">¿Cuál es la cobertura que tiene Gastrocirugia Aguascalientes? </h2>
											<p className="mb-0">Actualmente, tenemos cobertura en los siguientes lugares</p>
										</div>
										<div className="row align-items-center">
										<div className="head-text mb-30">
											<h4 className="title mb-10">Aguascalientes</h4>
 										</div>
											<div className="col-md-11 mb-30">
												<ul className="list-check-squer mb-0">
													<li>Jesús Maria</li>
													<li>Rincon de Romos</li>
												</ul>
											</div>
										</div>

										<div className="head-text mb-30">
											<h4 className="title mb-10">Jalisco</h4>
 										</div>
											<div className="col-md-11 mb-30">
												<ul className="list-check-squer mb-0">
													<li>Jalisco</li>
													<li>Encarnación de Diaz</li>
													<li>San Juan de los Lagos</li>
													<li>Ojuelos</li>
												</ul>
											</div>
										</div>


										<div className="head-text mb-30">
											<h4 className="title mb-10">Zacatecas</h4>
 										</div>
											<div className="col-md-11 mb-30">
												<ul className="list-check-squer mb-0">
													<li>Pinos</li>
												</ul>
											</div>
											<div className="head-text mb-30">
										
											<p className="mb-0">En caso de alguna pregunta, No dude en ponerse en contacto en cualquier momento para analizarlo más a fondo</p>
										</div>
										 
										</div>

								<div className="col-lg-4">
									<aside className="sticky-top pb-1">
									<div className="head-text mb-30">
											<h4 className="title mb-10">Padecimientos</h4>
 										</div>
										<div className="widget">
											<ul className="service-menu">
											<li ><Link to="/service_ct"><span>Colecistectomía Laparoscópica</span><i className="fa fa-angle-right"></i></Link></li>
												<li className="active"><Link to="/service_erge"><span>Funduplicatura</span><i className="fa fa-angle-right"></i></Link></li> 
											</ul>
										</div>
										<div className="head-text mb-30">
											<h4 className="title mb-10">Servicios</h4>
 										</div>
										<div className="widget">
											<ul className="service-menu">
												<li><Link to="/service_ct"><span>Enfermedades Digestivas Quirúrgicas</span></Link></li>
												<li><Link to="/service_e"><span>Enfermedades Digestivas Médicas</span></Link></li>
												<li><Link to="/service_t"><span>Tratamiento Médico</span></Link></li>
											</ul>
										</div>
										<div className="head-text mb-30">
											<h4 className="title mb-10">Convenios</h4>
 										</div>
										 <div className="widget">
											<ul className="service-menu">
												<li>
												<a
													href="https://www.laboratoriosyalab.mx/"
													target="_blank"
													rel="noopener noreferrer"
												>
													<span>Laboratorios Yalab</span>
												</a>
												</li>
											</ul>
											</div>

									</aside>
								</div>
								
							</div>
						</div>
					</section>
					
				</div>
				
				<Footer />
				
			</>
		);
	}
}

export default ServiceCover;
